import { render, staticRenderFns } from "./RegisterQuestion.vue?vue&type=template&id=84b210be&scoped=true"
import script from "./RegisterQuestion.vue?vue&type=script&lang=js"
export * from "./RegisterQuestion.vue?vue&type=script&lang=js"
import style0 from "./RegisterQuestion.vue?vue&type=style&index=0&id=84b210be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b210be",
  null
  
)

export default component.exports